import { render, staticRenderFns } from "./IconBox.vue?vue&type=template&id=df513be8&"
import script from "./IconBox.vue?vue&type=script&lang=coffee&"
export * from "./IconBox.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports